import { render } from "./tabNavigation.vue?vue&type=template&id=1db72374&scoped=true&ts=true"
import script from "./tabNavigation.vue?vue&type=script&lang=ts"
export * from "./tabNavigation.vue?vue&type=script&lang=ts"

import "./tabNavigation.vue?vue&type=style&index=0&id=1db72374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db72374"],['__file',"src/components/layout/tabNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1db72374"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1db72374', __exports__)) {
    api.reload('1db72374', __exports__)
  }
  
  module.hot.accept("./tabNavigation.vue?vue&type=template&id=1db72374&scoped=true&ts=true", () => {
    api.rerender('1db72374', render)
  })

}


export default __exports__